import { useAccountIds } from '../../../auth/accessToken/withAccountIds';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { usePayoutDestination } from '../hooks';

type PayoutDestinationDetailsProps = {
    payout_destination_id: string;
}

export const PayoutDestinationDetails = ({ payout_destination_id }: PayoutDestinationDetailsProps) => {
    const accountIds = useAccountIds();
    const accountId = accountIds.prodAccountId;
    const { payoutDestination } = usePayoutDestination(payout_destination_id);
    if (!payoutDestination) return <>{payout_destination_id}</>;
    return <Link to={`/${accountId}/settings/sellers/${payout_destination_id}`}>{payoutDestination?.name}</Link>;
};

export default memo(PayoutDestinationDetails);
